import { createContext } from 'preact'
import type { ClientCompanyViewDto, ClientWorkspaceSummaryViewDto } from '@/types/company'

export interface CompanyState {
  companyId?: string | null
  company?: ClientCompanyViewDto | null
  workspaces: ClientWorkspaceSummaryViewDto[]
  authOrganizationId?: string | null
  hasEnabledAuthConnections?: boolean
  currentWorkspaceId?: string | null
  isLoading: boolean
  error?: string | null
  refresh: () => Promise<void>
  setCurrentWorkspace: (workspaceId: string) => void
  updateCompany: (company: ClientCompanyViewDto) => void
  addWorkspace: (ws: ClientWorkspaceSummaryViewDto) => void
  updateWorkspace: (ws: ClientWorkspaceSummaryViewDto) => void
  removeWorkspace: (workspaceId: string) => void
  currentWorkspace?: ClientWorkspaceSummaryViewDto | null
}

export const CompanyContext = createContext<CompanyState | null>(null)
